export default "__VITE_ASSET__f2e30410__"